<template>
  <div>
      <ul class="list-unstyled list-social footer__list-social" v-if="DBitems.social">
        <li class="list-social__item">
       <a v-if="DBitems.social.instgram" target="_blank" :href="DBitems.social.instgram">
              <i class="bi bi-instagram"></i>  
            </a>
             </li>
               <li class="list-social__item">
            <a v-if="DBitems.social.twiter" target="_blank" :href="DBitems.social.twiter"
              ><i class="bi bi-twitter-x" ></i></a>
              </li>
               <li class="list-social__item">
            <a v-if="DBitems.social.facebook" target="_blank" :href="DBitems.social.facebook"
              ><i class="bi bi-facebook" ></i></a>
              </li>

               <li class="list-social__item">
             <a v-if="DBitems.social.tiktok" target="_blank" :href="DBitems.social.tiktok">
              <i class="bi bi-tiktok" ></i></a>
              </li>
               <li class="list-social__item">
            <a v-if="DBitems.social.whatsapp" target="_blank" :href="'https://api.whatsapp.com/send?phone='+DBitems.social.whatsapp+'&text=Hello!'"
              > <i class="bi bi-whatsapp" ></i></a></li>
               <li class="list-social__item">
            <a v-if="DBitems.social.snapchat" target="_blank" :href="DBitems.social.snapchat"
              ><i class="bi bi-snapchat" ></i></a></li>

               <li class="list-social__item">
              <a v-if="DBitems.social.email" target="_blank" :href="'mailto:'+DBitems.social.email"
              ><i class="bi bi-envelope" ></i></a>
              </li>
                  <li class="list-social__item">
              <a v-if="DBitems.social.phone" target="_blank" :href="'to:'+DBitems.social.phone"
              ><i class="bi bi-telephone-outbound" ></i></a>
              </li>
    </ul>
    <hr>
    <footer  v-if="DBitems&&DBitems.market" class=" text-muted " >
  <p v-if="DBitems.market.copy_right">© 2025, {{ DBitems.market.copy_right }} – 
    <router-link class="text-muted" style="text-decoration: none;" :to="{
                          name: 'privacy',
                          params: { storeName: $store.storeName, lang: $store.state.routeLang },
                        }" >
                        {{ $t('privacyPolicy') }} </router-link></p>

                        <p v-else>© 2025,  {{ DBitems.market.name }}.{{$t('Powered By Etrolley')}} – 
    <router-link class="text-muted" style="text-decoration: none;" :to="{
                          name: 'privacy',
                          params: { storeName: $store.storeName, lang: $store.state.routeLang },
                        }" >
                        {{ $t('privacyPolicy') }} </router-link></p>
</footer>
  </div>
</template>
<script>
//import { KinesisContainer, KinesisElement} from 'vue-kinesis'
export default {
  // eslint-disable-next-line
  /*eslint-disable */
  name: "Footer",
  //components:{ KinesisContainer, KinesisElement },
  props: {
    // msg: String,
  },
  data: function () {
    return {
      //storeName: "markat",
      logo: "",
      DBitems: null,
      loading: false,
      country: 6,
      countries: [],
    };
  },
  created() {
    this.loading = true;
    this.$store.storeName = this.$store.state.storeName;
    console.log(this.$store.storeName);
    this.axios
      .get(this.$store.state.base_api_url + this.$store.storeName + "/footer",
      {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        })
      .then((response) => (this.DBitems = response.data.data))
      .then(() => (this.loading = false));

  },

  watch:{
    lang(newVal) {
      this.$store.state.langchange = true;
      this.$store.state.langchange1 = true; //for footer
     
       this.axios
      .get(this.$store.state.base_api_url + this.$store.storeName + "/footer",
      {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        })
      .then((response) => (this.DBitems = response.data.data))
      .then(() => (this.loading = false));

    }

  }
};
</script>